import React from 'react';
import { useTranslation } from 'react-i18next';
import InputField from '../../../components/fields/InputField';
import SwitchField from '../../../components/fields/SwitchField';
import useSystemSwitchData from '../../../utilities/useSystemSwitchData';

const KYCPresetInfo = () => {
    const { t } = useTranslation('localCustomerModuleDetails');
    const { yesNoSwitch } = useSystemSwitchData();

    return (
        <>
            <InputField
                {...t('localCustomerModuleDetails:kycPresetsDrawer.fields.displayName', {
                    returnObjects: true,
                })}
                name="displayName"
                required
            />
            <SwitchField
                {...t('localCustomerModuleDetails:kycPresetsDrawer.fields.active', {
                    returnObjects: true,
                })}
                name="isActive"
                {...yesNoSwitch}
                required
            />
        </>
    );
};

export default KYCPresetInfo;
